<template>
    <div>
        <TableList
            ref="table_list"
            style_mode="pop"
            :columns="columns"
			:where='where'
            :is_created_get_list="true"
            :get_table_list="get_table_list"
            :form_data_seo="form_data_seo"
			rowKey="id"
        >
        </TableList>
    </div>
</template>

<script>
    import TableList from "@/components/TableList";
    import {getCustomerList} from "@/api/customer";

    export default {
        components: {
            TableList
        },
        props: {
            ruleCustomerData: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                get_table_list:getCustomerList,
                form_data_seo: {
                    list: [
                        {
                            type: "text",
                            name: "keyword",
                            title: "客户",
                            placeholder: '客户名称/地址/ID',
                            options: {}
                        },
                    ],
                    ...this.$config.form_data_seo
                },

                columns:[
                    {
                        title: "客户ID",
                        dataIndex: "id",
                    },
                    {
                        title: "客户名称",
                        dataIndex: "name",
                    },
                    {
                        title: "客户类型",
                        dataIndex: "group",
                    },
                    {
                        title: "客户地址",
                        dataIndex: "address",
                    },
                ],

                where:{
                    group_id:''
                },

            }
        },
        watch: {
            ruleCustomerData: {
                handler(newValue, oldValue) {
                    this.where.group_id = newValue
                    this.$refs.table_list.rest_get_list();
                }
            },
        },
        created() {
            this.where.group_id = this.ruleCustomerData
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    
</style>